import { defineComponent } from 'vue';
import { StudyCardTrackingInformationOptions } from '../../../../interfaces/props.interfaces';

import StudyCardTrackingInformation from './StudyCardTrackingInformation.class';

export default defineComponent({
	props: {
		id: String,
		title: String,
		enhanced: Boolean,
	},

	setup: (props: any) => {
		const options = props as StudyCardTrackingInformationOptions;

		const component = new StudyCardTrackingInformation(options.id, options.title, options.enhanced);

		return {
			dataLabel: component.dataLabel,
		};
	},
});
